import {DataStatus, Form, FormField} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useGetBranchListQuery} from '@dms/api/core';
import {useGetWarehousesQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {getOptionsFromBranches, getOptionsFromWarehouses} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {FormToDataGridConnectorProps} from 'features/eag-grid';

type ArticleListExternalFiltersForm = Partial<{
  branchId: string;
  warehouseId: string;
  catalogNumber: string;
  isAvailable: boolean;
  isInStock: boolean;
}>;

type ArticleListExternalFiltersFormProps = FormToDataGridConnectorProps & TestIdProps;

export function ArticleListExternalFilters(props: ArticleListExternalFiltersFormProps) {
  const {
    data: warehouses,
    isLoading: isWarehousesLoading,
    isError: isWarehousesError,
  } = useGetWarehousesQuery();

  const {
    data: branches,
    isLoading: branchesLoading,
    isError: isBranchesError,
  } = useGetBranchListQuery();

  const isLoading = isWarehousesLoading || branchesLoading;
  const isError = isWarehousesError || isBranchesError;

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <Form<ArticleListExternalFiltersForm>
        defaultValues={{}}
        values={props.values}
        onChange={props.onChange}
      >
        {(control) => (
          <VStack spacing={4}>
            <FormField
              control={control}
              name="catalogNumber"
              type="text"
              label={i18n.t('entity.warehouse.labels.catalogueNumber')}
              data-testid={suffixTestId('catalogueNumber', props)}
            />
            <FormField
              control={control}
              name="branchId"
              type="multiChoice"
              label={i18n.t('entity.branch.labels.branch')}
              options={getOptionsFromBranches(branches)}
              data-testid={suffixTestId('branch', props)}
            />
            <FormField
              control={control}
              name="warehouseId"
              type="multiChoice"
              label={i18n.t('entity.warehouse.labels.warehouse')}
              options={getOptionsFromWarehouses(warehouses)}
              data-testid={suffixTestId('warehouse', props)}
            />
            <FormField
              control={control}
              name="isAvailable"
              label={i18n.t('entity.warehouse.labels.availableOnly')}
              type="checkbox"
              data-testid={suffixTestId('availableOnly', props)}
            />
            <FormField
              control={control}
              name="isInStock"
              label={i18n.t('entity.warehouse.labels.inStock')}
              type="checkbox"
              data-testid={suffixTestId('inStock', props)}
            />
          </VStack>
        )}
      </Form>
    </DataStatus>
  );
}
